import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    fill: "none",
    viewBox: "0 0 36 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M19.885 2.077l13.82 23.692c.838 1.436-.21 3.231-1.884 3.231H4.179c-1.675 0-2.722-1.795-1.884-3.23l13.82-23.693c.838-1.436 2.932-1.436 3.77 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.503 11.124C16.453 10.514 17.137 10 18 10c.862 0 1.547.513 1.497 1.122l-.587 7.275c-.027.338-.424.603-.903.603-.479 0-.874-.264-.902-.602l-.602-7.274zM17 21.766c0-.536.448-.971 1-.971s1 .434 1 .97v.059c0 .536-.448.97-1 .97s-1-.434-1-.97v-.058z"
  })));
}

export { SvgWarning as ReactComponent };
//# sourceMappingURL=Warning.svg.js.map
